import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from "../../../../components/Tabella/TabellaLista";
import { ChipFilter, filtroMultiplo } from "../../../../components/Tabella/ChipFilter";
import { RangeFilterButton, dataNelPeriodo } from "../../../../components/Tabella/RangeFilterButton";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { sports } from "../../../../components/Util/enum";

// Valori del filtro a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Attivo', 'Completato', 'Inattivo'];
const dataBreve = (iso) => (iso ? new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—');

export const ListaMaestri = () => {
    const navigate = useNavigate();

    const [data_json, setDataJson] = useState(null);
    // Chip a scelta multipla: all'inizio tutti accesi
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);
    // Periodo (TASK #14, 21/10/2026): data di registrazione del maestro
    const [periodo, setPeriodo] = useState({});

    const filteredData = useMemo(
        () =>
            data_json &&
            data_json.filter((row) => filtroMultiplo(statoFilter, STATO_OPTIONS, row.status?.label) && dataNelPeriodo(row.createdAt, periodo.periodo)),
        [data_json, statoFilter, periodo],
    );

	const [loadingShowed, setLoadingShowed] = useState(false);

    const data_column = [
        { Header: 'Data', Footer: 'Data', accessor: 'createdAt', compact: true, disableGlobalFilter: true, Cell: ({ value }) => dataBreve(value) },
        {
            Header: 'Nome e Cognome',
            Footer: 'Nome e Cognome',
            accessor: 'name',
            Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  <img
					src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
					alt={row.original.name}
					style={{
					  width: '40px',
					  height: '40px',
					  borderRadius: '50%',
					  marginRight: '10px'
					}}
				  />
				  {row.original.name}
				</div>
			)
        },
        {
            Header: 'Email',
            Footer: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Sport',
            Footer: 'Sport',
            accessor: 'sports',
        },
        {
            Header: 'Stato',
            Footer: 'Stato',
            id: 'status',
            accessor: row => row.status ? row.status.label : '',
            Cell: ({ row }) => {
                const status = row.original.status;
                if (!status) return '';
                const { class: cls, label } = status;
                return (
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${cls}`} />
                        {label}
                    </div>
                );
            },
            disableGlobalFilter: true,
        },
        /*{
            Header: 'Stato richiesta',
            Footer: 'Stato richiesta',
            accessor: 'requeststatus',
            Cell: ({ value }) => {
                return (value &&
                    <div className="d-flex align-items-center">
                        <i className={`fa fa-circle me-1 ${value.class}`}></i>
                        {value.label}
                    </div>
                );
            },
            disableFilters: true,
        },*/
    ];

    function openDetail(row) {
		navigate('/superadmin/anagrafiche/maestri/'+row.id);
	}

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();
            
                    setLoadingShowed(true);
                    const [membershipData] = await Promise.all([
                        apiClient.getProfilesByFilters(token,10000,null,'IDS_GURU')
                    ]);
                    setLoadingShowed(false);
            
                    if(membershipData) {
                        let data_member = [];
                        membershipData.items.forEach(element => {
            
                            let image = null;
                            if(element.pictures && element.pictures[0] && element.pictures[0].uri) {
                                image = element.pictures[0].uri;
                            }
            
                            let status = null;
                            if(element.guruProfileStatus==='INACTIVE') {
                                status = {
                                    "label": "Inattivo",
                                    "class": "text-danger"
                                };
                            } else if(element.guruProfileStatus==='ACTIVE') {
                                status = {
                                    "label": "Attivo",
                                    "class": "text-success"
                                };
                            } else if(element.guruProfileStatus==='COMPLETED') {
                                status = {
                                    "label": "Completato",
                                    "class": "text-success"
                                };
                            }

                            let sports_taught = '';
                            if(element.taughtSportTypes) {
                                element.taughtSportTypes.forEach(element => {
                                    sports.forEach(element2 => {
                                        if(element2.value === element) {
                                            sports_taught += element2.label+'. ';
                                        }
                                    });
                                });
                            }
            
                            let member_row = {
                                "id": element.userId,
                                "name": element.name,
                                "imageUrl": image,
                                "status": status,
                                "email": element.email,
                                "createdAt": element.createdAt || null,
                                sports: sports_taught
                            };
                            data_member.push(member_row);
            
                        });
                        setDataJson(data_member);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData();
    
    }, []);

    return (
        <>

            <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Fragment>
                <TabellaLista
                    openColumn={'name'}
                    openRow={(row) => openDetail(row)}
                    cardTitle={'Staff tecnico'}
                    pageList={true}
                    hasSearch={true}
                    searchPlaceholder={'Cerca per nome, email o sport'}
                    hasFilter={false}
                    filterControl={
                        <div className="sid-chip-filters">
                            <RangeFilterButton label="Periodo" ranges={[{ key: 'periodo', label: 'Data di registrazione', type: 'date' }]} value={periodo} onApply={setPeriodo} />
                            <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                        </div>
                    }
                    hasAddMore={false}
                    data_column={data_column}
                    data_json={filteredData}
                />

                {/*<Alert variant="danger">
                    <Alert.Heading>Attenzione</Alert.Heading>
                    <p>
                        La lista è in fase di creazione.<br/>
                        Le "Azioni" non sono definitive
                    </p>
                </Alert>*/}

            </Fragment>
        </>
    )
}

export default ListaMaestri